import { Navigate } from "react-router-dom"
import { useContext } from "react"
import { UserContext } from "../../Hooks/UserContext"

const DocumentProtection = ({children})=>{
    const {user} = useContext(UserContext)
    const token = localStorage.getItem("token")
    if(token){
    if(user!==null){
if(user.isFormSubmit === "0" ||!user.isFormSubmit){
    return children
}
return <Navigate to="/driver_forms/profile" />
}
    }else{
       return <Navigate to="/driver_forms/login" />
    }   
}

export default DocumentProtection